module.exports = __webpack_public_path__ + "static/media/logo.271eb0c2.png";